module.exports = __webpack_public_path__ + "static/media/muted.9f169f15.svg";